import { palette } from 'assets/styles/colors';

const labelColor = palette.neutral[500];

const textField = {
  MuiTextField: {
    styleOverrides: {
      root: {
        margin: '16px 0 8px 0',
        '.MuiInputLabel-root': {
          color: labelColor,
        },
      },
    },
  },
};

export default textField;
